export class Cultura {
    Id: number;
    Descricao:string = "";
    EmpresaId: number;
    QtdPlanejamentos: number = 0;
    Icone:string = "";
    DataCadastro: Date;
}
